import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TableDropdown } from '@common/components/table';
import ConfirmButton from '@common/components/confirm-button';

import type { FormsData } from '../../types';

type FormActionsProps = {
  item: FormsData;
  onArchive: () => void;
  onDelete: () => void;
  onUnarchive: () => void;
};

export const FormActions = ({
  item,
  onArchive,
  onDelete,
  onUnarchive
}: FormActionsProps) => {
  const { t } = useTranslation();

  const confirmString = t('common:delete').toUpperCase();

  return (
    <TableDropdown>
      {item.status !== 'archived' && (
        <TableDropdown.Item icon="inventory" onClick={onArchive}>
          {t('performance:form_archive')}
        </TableDropdown.Item>
      )}
      {
        item.status === 'archived' && (
          <TableDropdown.Item icon="unarchive" onClick={onUnarchive}>
            {t('performance:form_unarchive')}
          </TableDropdown.Item>
        )
      }
      <ConfirmButton
        danger
        title={t('performance:form_confirm_delete')}
        confirmText={t('performance:form_delete')}
        description={(
          <Trans
            i18nKey="performance:form_delete_description"
            values={{ confirmString }}
            components={[<b />]}
          />
        )}
        confirmString={confirmString}
        onConfirm={onDelete}
      >
        <TableDropdown.Item danger icon="delete" onClick={onDelete}>
          {t('performance:form_delete')}
        </TableDropdown.Item>
      </ConfirmButton>
    </TableDropdown>
  );
};
